<template>
  <znl-dialog
    :visible="visible"
    :title="title"
    :append-to-body="true"
    width="300px"
    :height="170"
    class="c-BatchSettingBoolean"
    @close="$emit('update:visible', false)"
  >
    <div v-if="BatchSettingBooleanConfig.SelectedRows.length > 0">
      {{ `已选择${BatchSettingBooleanConfig.SelectedRows.length}条数据` }}
    </div>
    <div
      v-else
      :style="{ fontSize: '12px', lineHeight: '22px', color: '#666' }"
    >
      * 按当前搜索条件批量修改全部数据。
    </div>
    <div
      :style="{ fontSize: '12px', lineHeight: '22px', color: '#666' }"
      v-if="BatchSettingBooleanConfig.type === 'IsWholePackage'"
    >
      * 若设置整包出售，确定后仍需批量导入MPQ。
    </div>

    <div v-if="BatchSettingBooleanConfig.type === 'IsWholePackage'">
      <el-radio
        v-model="value"
        :label="true"
      >是</el-radio>
      <el-radio
        v-model="value"
        :label="false"
      >否</el-radio>
    </div>
    <div>
      <znl-input
        v-if="BatchSettingBooleanConfig.type === 'IsInvoice'"
        class="pull-left"
        :width="100"
        :border="true"
        form-type="select"
        :select-options="selectOptions"
        :style="{ marginTop: '12px' }"
        v-model="NewTaxRate"
      ></znl-input>
    </div>

    <div slot="footer">
      <znl-button
        :width="60"
        :height="30"
        @click="$emit('update:visible', false)"
      >
        取消
      </znl-button>
      <znl-button
        style-type="main"
        :width="60"
        :height="30"
        class="ml"
        @click="batchSettingHandler"
      >
        确定
      </znl-button>
    </div>
  </znl-dialog>
</template>
<script>
import { httpPost } from '../../assets/scripts/http';

export default {
  name: 'BatchSettingBoolean',
  props: {
    visible: Boolean,
    BatchSettingBooleanConfig: {
      type: Object,
      default() {
        return {};
      }
    },
    saveHandler: Function,
    onBindData: Function,
    Model: String,
    Brand: String,
    StandardPriceStart: String,
    StandardPriceEnd: String,
    StepPlanGuid: String,
    IsUnUsual: Boolean,
    getIsInvoice: Function
  },
  computed: {
    title() {
      let title = '';
      switch (this.BatchSettingBooleanConfig.type) {
        case 'IsInvoice':
          title = '批量设置是否可开票';
          break;
        case 'IsWholePackage':
          title = '批量设置是否整包出售';
          break;
        default:
          title = '';
          break;
      }
      return title;
    }
  },
  data() {
    return {
      value: false,
      NewTaxRate: 13,
      selectOptions: [
        { key: 13, value: '可开票 13%' },
        { key: 3, value: '可开票 3%' },
        { key: 0, value: '不可开票' }
      ]
    };
  },
  methods: {
    batchSettingHandler() {
      const Datas = this.BatchSettingBooleanConfig.SelectedRows;
      const Type = this.BatchSettingBooleanConfig.type;
      if (Datas.length > 0) {
        Datas.forEach(item => {
          item[Type] = this.value;
        });
        if (this.saveHandler) {
          this.$emit('update:visible', false);
          this.saveHandler(Datas);
        }
      } else {
        const Params = {
          Model: this.Model,
          Brand: this.Brand,
          StandardPriceStart: this.StandardPriceStart,
          StandardPriceEnd: this.StandardPriceEnd,
          StepPlanGuid: this.StepPlanGuid,
          IsUnUsual: this.IsUnUsual,
          TaxRate: this.getIsInvoice ? this.getIsInvoice() : ''
        };
        switch (this.BatchSettingBooleanConfig.type) {
          case 'IsInvoice':
            // Params.NewIsInvoice = this.value;
            Params.NewTaxRate = this.NewTaxRate;
            break;
          case 'IsWholePackage':
            Params.NewIsWholePackage = this.value;
            break;
          default:
            break;
        }
        httpPost('shareStock/BatchChangePriceSetAsyncAsync', Params).then(
          res => {
            if (res.Code === 0) {
              this.$emit('update:visible', false);
              if (
                this.BatchSettingBooleanConfig.type === 'IsWholePackage' &&
                this.value
              ) {
                // 设置整包为true时跳转设置MPQ
                this.$emit('isShowBatchMPQ', true);
              } else {
                this.$alert('设置成功！将在8分钟内完成更新。', '提示', {
                  confirmButtonText: '确定'
                });
              }
            } else {
              this.$erroMess(res.Message);
            }
          }
        );
      }
    }
  }
};
</script>
<style lang="scss">
.c-BatchSettingBoolean {
  .znl-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
    line-height: 30px;
    .el-checkbox,
    .el-checkbox__label {
      font-size: 14px;
    }
  }
  .ml {
    margin-left: 10px;
  }
  .el-radio__label {
    font-size: 12px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #ee7700;
    font-size: 12px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #ee7700;
    background: #ee7700;
  }
}
</style>
